
import React, { useCallback, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
// import MainLayout from '../../layouts/MainLayout';
import axios from 'axios';
import "./styles/AICounselling.css";
import AICounsellingImage from '../../assets/pageimages/AICounsellingBanner.webp';
import { GenerateAICounsellingOrderNumber} from '../../components/GenerateThink5whysCode';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';

const AICounselling = () => {
    const authState = useSelector(state => state.authReducer);
    const navigate = useNavigate();
    const [fetchData, { loading }] = useFetch();
  
    const [userId, setUserId] = useState(authState.user._id);
    const [userName, setUserName] = useState(authState.user.name);
    const [userCode, setUserCode] = useState(authState.user.think5whyscode);
    const [error, setError] = useState(null);

    const [showProfile1, setShowProfile1] = useState(false);
    const [showProfile2, setShowProfile2] = useState(false);

    const cbseSubjects = [
        "English",
        "Hindi",
        "Mathematics",
        "Science",
        "Social Science",
        "Physics",
        "Chemistry",
        "Biology",
        "Computer Science",
        "Geography",
        "History",
        "Economics",
        "Civics",
        "Physical Education",
        "Fine Arts",
        "Sanskrit",
    
        "Environmental Science",
        "Commercial Studies",
        "Commercial Applications",
        "Art",
        "Music",
        "Home Science",
        "Physical Science",
    
        "Political Science",
        "Accountancy",
        "Business Studies",
        "Applied Mathematics",
        "Entrepreneurship",
        "Psychology",
        "Sociology",
        "Legal Studies",
        "Engineering Graphics",
        "Biotechnology",
        "Multimedia and Web Technology",
        "Informatics Practices"
    ];

    const [category, setCategory] = useState('');
    const [question, setQuestion] = useState('');
    const [option, setOption] = useState('');

    const [subjects, setSubjects] = useState([{ name: "", marks: "" }]);
    const [psychometric, setPsychometric] = useState([{ category: "", question: "", option: "" }]);
    const [selectedCategory, setSelectedCategory] = useState("");
    const [selectedQuestion, setSelectedQuestion] = useState("");
    const [selectedAICounsellingOption, setSelectedAICounsellingOption] = useState("");

    const [availableSubjects, setAvailableSubjects] = useState(cbseSubjects);
    const [strongestSubject, setStrongestSubject] = useState(null);
    const [weakestSubject, setWeakestSubject] = useState(null);
    const [selectedSubject, setSelectedSubject] = useState("");
    const [percentage, setPercentage] = useState("");
    // const [rcaCode, setRCACode] = useState('');
    const [rcaData, setRCAData] = useState([]);
    const [paymentConfirmClicked, setPaymentConfirmClicked] = useState(false);

    const [saved, setSaved] = useState(false);
    const [saveClicked, setSaveClicked] = useState(false);
    const [aiResponse, setAiResponse] = useState('');

    const [showSuggestions, setShowSuggestions] = useState(false);

    const [claimed, setClaimed] = useState(false);
    const [claimClicked, setClaimClicked] = useState(false);

    const toggleSuggestions = () => {
      setShowSuggestions(!showSuggestions);
    };
    
    const [rcaBookStatus, setRcaBookStatus] = useState(false);
    useEffect(() => {
        const config = { 
          url: `/mybooks/think5whysbookbuyingstatus`, 
          method: "post", 
          headers: { Authorization: authState.token },
          data: {userId: userId} 
        };
    
        fetchData(config, { showSuccessToast: false })
          .then((data) => {
            setRcaBookStatus(true);
        })
        .catch((error) => {
          console.error("Error fetching Think5Whys Main BOK status:", error);
          setError("Error fetching Think5Whys Main BOK status");
        });
    }, [authState, userId, fetchData, setRcaBookStatus]);

    const [rcaCreditStatus, setRcaCreditStatus] = useState(false);
    useEffect(() => {
        const config = {
          url: "/pocket/myrcabookcredit",
          method: "post",
          headers: { Authorization: authState.token },
          data: {userId: userId}
        };

        fetchData(config, { showSuccessToast: false })
          .then((data) => {
            if (data.status === true) {
                setRcaCreditStatus(true);
            } else {
            setRcaCreditStatus(false);
            }
        })
        .catch((error) => {
          console.error("Error fetching Think5Whys Main BOK Credit status:", error);
          setError("Error fetching Think5Whys Main BOK Credit status");
        });
    }, [authState, userId, fetchData, setRcaCreditStatus]);
    
    const [payNowClicked, setPayNowClicked] = useState(false);
    // const [paymentAmount, setPaymentAmount] = useState(0);
    const [pocketBalanceAmount, setPocketBalanceAmount] = useState(0.00);
    const [pocketLastUpdated, setPocketLastUpdated] = useState(null);
    const [pocketLastUpdatedRemarks, setPocketLastUpdatedRemarks] = useState("");
    const [viewPocketClicked, setViewPocketClicked] = useState(false);

    const [orderNumber, setOrderNumber] = useState(GenerateAICounsellingOrderNumber());
    const [invoice, setInvoice] = useState(GenerateAICounsellingOrderNumber());
    const [customerName, setCustomerName] = useState(authState.user.name);
    const [purchaseDate, setPurchaseDate] = useState(new Date());
    const [qty, setQty] = useState(1);
    const [navigatedFromPocketPayment, setNavigatedFromPocketPayment] = useState(0);
    const [counsellorId, setCounsellorId] = useState('');
    const [counsellorCode, setCounsellorCode] = useState('');
    const [counsellorName, setCounsellorName] = useState('');
    const [counsellorCodeStatus, setCounsellorCodeStatus] = useState(false);
    const [counsellorCodeStatusMsg, setCounsellorCodeStatusMsg] = useState('');
    const [counsellorCodeButtonClicked, setCounsellorCodeButtonClicked] = useState(false);

    const [aiPromptClicked, setAiPromptClicked] = useState(false);
    const [aiAssessmentClicked, setAiAssessmentClicked] = useState(false);
    const [jobAiPromptClicked, setJobAiPromptClicked] = useState(false);

    const [jobAiAssessmentClicked, setJobAiAssessmentClicked] = useState(false);

    const [formData, setFormData] = useState({
        userId: userId,
        userCode: userCode,
        userName: userName,
        aptitudeScore: "",
        aptitudeCode: "",
        interestAreas: "",
        personalityType: "",
        academicDataCode: "",
        examTitle: "",
        subjects:[],
        careerGoal: "",
        timeline: "",
        milestones: [],
        milestoneCode: "",
        aiAssessmentPrompt: "",
        aiAssessment: "",
        psychometric:  [],
        rcaCode: "",
        createdBy: userId,
        dateCreated: new Date(),
        isActive: true,
        isDeleted: false,
        myCounsellor: '',
        myCoupon: '',
        counsellorReport:'',
        counsellorName: '',
        dateReportUpdated: null,
        paymentAmount: 0.00,
        orderNumber: orderNumber,
        item: '',
        selectedSpendPlan: -1,

        personality: '',
        education: '',
        experience: '',
        skills: '',
        testScores: '',

        workEnvironment: "",
        dailyRoutine: "",
        timeManagement: "",
        distractions: "",
        productivityGoals: "",

        performanceMetrics: "",
        feedbackReceived: "",
        skillGaps: "",
        notableAchievements: "",
        negotiationStrategy: "",

        jobSecurityConcerns: "",
        performanceIssues: "",
        companyStability: "",
        professionalNetwork: "",
        contingencyPlan: "",

        monthlyIncome: "",
        monthlyExpenses: "",
        savingsAndInvestments: "",
        debtManagement: "",
        financialGoals: "",
        emergencyFund: "",

        stressors: "",
        workLifeBalance: "",
        personalRelationships: "",
        mentalHealth: "",
        copingMechanisms: "",

        communicationPatterns: "",
        emotionalConnection: "",
        conflictResolution: "",
        timePriorities: "",
        trustRespect: "",
        parentingDynamics: "",
        supportSystems: "",
        personalGrowthChange: "",

        emotionalExpression: "",
        behavioralChallenges: "",
        socialization: "",
        academicPerformance: "",
        familyDynamics: "",
        sleepRoutine: "",
        selfEsteemConfidence: "",
        // copingMechanisms: "",
        disciplineExpectations: "",
        healthNutrition: "",

        commentby1Code:  "",
        commentby1Name:  "",
        commentby1:  "",
        commentby1Date: null,
        commentby1AI:  "",

        commentby2Code:  "",
        commentby2Name:  "",
        commentby2:  "",
        commentby2Date: null,
        commentby2AI:  "",

        commentby3Code:  "",
        commentby3Name:  "",
        commentby3:  "",
        commentby3Date: null,
        commentby3AI:  "",

        commentby4Code:  "",
        commentby4Name:  "",
        commentby4:  "",
        commentby4Date: null,
        commentby4AI:  "",


        counsellingType: 1,
    });

    const aipath = (location?.pathname || '').split('/').pop() || '';
    const isKids = (location?.pathname || '').split('-').pop() || '';
    const isJob = (location?.pathname || '').split('-').pop() || '';

    const counsellingOptions = (() => {
        if (isJob === "job") {
            return [
                { value: "2", label: "Job Search", icon: "fa-solid fa-user-tie" },
                { value: "3", label: "Productivity Increase", icon: "fa-solid fa-chart-line" },
                { value: "4", label: "Increment Focus", icon: "fa-solid fa-bullseye" },
                { value: "5", label: "Job Risk Mitigation", icon: "fa-solid fa-shield-alt" },
                { value: "6", label: "Financial", icon: "fa-solid fa-indian-rupee-sign" },
                { value: "7", label: "Life Issues", icon: "fa-solid fa-heart" },
                { value: "10", label: "Mental Health", icon: "fa-solid fa-brain" },
                { value: "11", label: "Farmer", icon: "fa-solid fa-tractor" },
                { value: "12", label: "MSME", icon: "fa-solid fa-industry" },
                { value: "13", label: "Mothers", icon: "fa-solid fa-person-breastfeeding" },
                { value: "14", label: "Worker", icon: "fa-solid fa-people-carry" }
            ];
            }

            else if (isKids === "kids") {
            return [
                { value: "7", label: "Life Issues", icon: "fa-solid fa-heart" },
                { value: "9", label: "Child Behaviour", icon: "fa-solid fa-child-reaching" },
                { value: "10", label: "Mental Health", icon: "fa-solid fa-brain" }
            ];
            }

            else {
            return [
                { value: "1", label: "Regular Study / Career", icon: "fa-solid fa-book-open" },
                { value: "2", label: "Job Search", icon: "fa-solid fa-user-tie" },
                { value: "3", label: "Productivity Increase", icon: "fa-solid fa-chart-line" },
                { value: "4", label: "Increment Focus", icon: "fa-solid fa-bullseye" },
                { value: "5", label: "Job Risk Mitigation", icon: "fa-solid fa-shield-alt" },
                { value: "6", label: "Financial", icon: "fa-solid fa-indian-rupee-sign" },
                { value: "7", label: "Life Issues", icon: "fa-solid fa-heart" },
                { value: "8", label: "Marriage / Family", icon: "fa-solid fa-users" },
                { value: "9", label: "Child Behaviour", icon: "fa-solid fa-child-reaching" },
                { value: "10", label: "Mental Health", icon: "fa-solid fa-brain" },
                { value: "11", label: "Farmer", icon: "fa-solid fa-tractor" },
                { value: "12", label: "MSME", icon: "fa-solid fa-industry" },
                { value: "13", label: "Mothers", icon: "fa-solid fa-person-breastfeeding" },
                { value: "14", label: "Worker", icon: "fa-solid fa-people-carry" }
            ];
        }
    })();

    const categories = ["General Well-being", "Stress and Anxiety", "Confidence", "Study Habits", "Motivation and Time Management"];

    const questions = {
        "General Well-being": [
        "How have you been feeling lately?",
        "Do you feel balanced between studies and personal life?",
        ],
        "Stress and Anxiety": [
        "Do you feel anxious before exams?",
        "How do you cope with stressful situations?",
        ],
        Confidence: [
        "Do you feel confident about your progress?",
        "How do you handle mistakes or failures?",
        ],
        "Study Habits": [
        "Do you take breaks during study sessions?",
        "Do you have a support system (family, friends, mentors)?",
        ],
        "Motivation and Time Management": [
        "Do you feel motivated to achieve your goals?",
        "How do you manage your time for studies and other activities?",
        ],
    };

    const options = {
        "How have you been feeling lately?": [
            "Good and motivated",
            "Okay but stressed",
            "Overwhelmed or low",
        ],
        "Do you feel balanced between studies and personal life?": [
            "Yes, I balance well",
            "Sometimes it’s overwhelming",
            "I feel I have no personal time",
        ],
        "Do you feel anxious before exams?": [
            "Yes, very anxious",
            "Somewhat anxious",
            "No, I feel confident",
        ],
        "How do you cope with stressful situations?": [
            "Talk to someone I trust",
            "Take breaks or relax",
            "Struggle to manage stress",
        ],
        "Do you feel confident about your progress?": [
            "Yes, I feel on track",
            "I have doubts sometimes",
            "No, I feel behind",
        ],
        "How do you handle mistakes or failures?": [
            "Learn from them and move on",
            "Feel upset but try again",
            "Lose motivation and feel discouraged",
        ],
        "Do you take breaks during study sessions?": [
            "Yes, regularly",
            "Sometimes, but not often",
            "No, I study for long hours without breaks",
        ],
        "Do you have a support system (family, friends, mentors)?": [
            "Yes, I have strong support",
            "Somewhat, but could use more support",
            "No, I feel alone",
        ],
        "Do you feel motivated to achieve your goals?": [
            "Yes, highly motivated",
            "Motivated but get distracted",
            "Struggle to stay motivated",
        ],
        "How do you manage your time for studies and other activities?": [
            "Plan and stick to a schedule",
            "Try but often fail to manage time",
            "Feel overwhelmed and disorganized",
        ],
    };
    
    // Handle selecting an option for each question in each category
    const handleOptionChange = (category, question, option) => {
        const updatedPsychometric = [...formData.psychometric];
        const existingCategoryIndex = updatedPsychometric.findIndex(
            (item) => item.category === category
        );

        if (existingCategoryIndex !== -1) {
            const questions = [...updatedPsychometric[existingCategoryIndex].questions];
            const existingQuestionIndex = questions.findIndex(
                (q) => q.question === question
            );

            if (existingQuestionIndex !== -1) {
                questions[existingQuestionIndex] = {
                    ...questions[existingQuestionIndex],
                    selectedOption: option,
                };
            } else {
                questions.push({ question, selectedOption: option });
            }

            updatedPsychometric[existingCategoryIndex] = {
                ...updatedPsychometric[existingCategoryIndex],
                questions,
            };
        } else {
            updatedPsychometric.push({
                category,
                questions: [{ question, selectedOption: option }],
            });
        }

        setFormData({
            ...formData,
            psychometric: updatedPsychometric,
        });
    };

    const handleProfile1Toggle = () => {
        setShowProfile1(!showProfile1);
    };

    const handleProfile2Toggle = () => {
        setShowProfile2(!showProfile2);
    };

    const handleAddSubject = () => {
        setFormData((prevState) => ({
            ...prevState,
            subjects: [...prevState.subjects, { name: "", marks: "" }],
        }));
    };
    
    const handleSubjectChange = (index, value) => {
        setFormData((prevState) => {
            const updatedSubjects = [...prevState.subjects];
            const previousValue = updatedSubjects[index]?.name;
    
            updatedSubjects[index].name = value;
    
            const newAvailableSubjects = previousValue
            ? [...availableSubjects, previousValue]
            : availableSubjects;

            // Filter out the newly selected subject
            const filteredAvailableSubjects = newAvailableSubjects.filter(
                (subject) => subject !== value
            );
    
            setAvailableSubjects(Array.from(new Set(filteredAvailableSubjects)));
    
            return {
                ...prevState,
                subjects: updatedSubjects,
            };
        });
    };
    
    const handleMarksChange = (index, value) => {
        setFormData((prevState) => {
            const updatedSubjects = [...prevState.subjects];
            updatedSubjects[index].marks = value <= 100 ? value : updatedSubjects[index].marks;
    
            return {
                ...prevState,
                subjects: updatedSubjects,
            };
        });
    };
    
    const handleRemoveSubject = (index) => {
        setFormData((prevState) => {
            const updatedSubjects = prevState.subjects.filter((_, i) => i !== index);
            const removedSubject = prevState.subjects[index]?.name;
    
            if (removedSubject) {
                setAvailableSubjects((prev) => Array.from(new Set([...prev, removedSubject])));
            }
    
            return {
                ...prevState,
                subjects: updatedSubjects,
            };
        });
    };
    
    useEffect(() => {
        if (formData.subjects.length > 0) {
            let highestMarks = -1;
            let lowestMarks = 101;
            let strongest = null;
            let weakest = null;
    
            formData.subjects.forEach((subject) => {
                const marks = Number(subject.marks);
                if (marks > highestMarks) {
                    highestMarks = marks;
                    strongest = subject.name;
                }
                if (marks < lowestMarks) {
                    lowestMarks = marks;
                    weakest = subject.name;
                }
            });
    
            setStrongestSubject(strongest);
            setWeakestSubject(weakest);
        } else {
            setStrongestSubject(null);
            setWeakestSubject(null);
        }
    }, [formData.subjects]);
    

    const [milestones, setMilestones] = useState([]);
    const [newMilestone, setNewMilestone] = useState("");

    const handlePullMilestone = () => {
        
    };

    const [isManualMilestone, setIsManualMilestone] = useState(false);
    const handleIsManualMilestone = () => {
        setIsManualMilestone(!isManualMilestone);
    };

    const handleMilestoneChange = (e) => {
    setNewMilestone(e.target.value);
    };
          
    const handleAddMilestone = () => {
    setFormData((prevState) => ({
        ...prevState,
        milestones: [...prevState.milestones, newMilestone],
    }));
    setNewMilestone(""); 
    };
      
    const handleRemoveMilestone = (index) => {
    const updatedMilestones = formData.milestones.filter((_, i) => i !== index);
    setFormData((prevState) => ({
        ...prevState,
        milestones: updatedMilestones,
    }));
    };
    
    const handlePullMockTestData = () => {
        
    };

    const handlePullAcademicData = () => {
        
    };

    const viewAICounsellingHistorytClicked = () => {
        navigate("/aicounselling-aihistory");
    };

    const viewPersonalCounsellingHistoryClicked = () => {
        navigate("/aicounselling-personalhistory");
    };

    const handlePullRCAData = () => {
        
    };

    const [studyCounsellingClicked, setStudyCounsellingClicked] = useState(false);
    const handleStudyCounsellingClicked = () => {
        setStudyCounsellingClicked(!studyCounsellingClicked);
    };

    const [jobSearchCounsellingClicked, setJobSearchCounsellingClicked] = useState(false);
    const handleJobSearchCounsellingClicked = () => {
        setJobSearchCounsellingClicked(!jobSearchCounsellingClicked);
    };

    const [jobSavingCounsellingClicked, setJobSavingCounsellingClicked] = useState(false);
    const handleJobSavingCounsellingClicked = () => {
        setJobSavingCounsellingClicked(!jobSavingCounsellingClicked);
    };

    const [piSearchCounsellingClicked, setPISearchCounsellingClicked] = useState(false);
    const handlePISearchCounsellingClicked = () => {
        setPISearchCounsellingClicked(!piSearchCounsellingClicked);
    };

    const [ifSearchCounsellingClicked, setIFSearchCounsellingClicked] = useState(false);
    const handleIFSearchCounsellingClicked = () => {
        setIFSearchCounsellingClicked(!ifSearchCounsellingClicked);
    };

    const [financialCounsellingClicked, setFinancialCounsellingClicked] = useState(false);
    const handleFinancialCounsellingClicked = () => {
        setFinancialCounsellingClicked(!financialCounsellingClicked);
    };

    const [lifeCounsellingClicked, setLifeCounsellingClicked] = useState(false);
    const handleLifeCounsellingClicked = () => {
        setLifeCounsellingClicked(!lifeCounsellingClicked);
    };

    const [mfCounsellingClicked, setMFCounsellingClicked] = useState(false);
    const handleMFCounsellingClicked = () => {
        setMFCounsellingClicked(!mfCounsellingClicked);
    };

    const [cbCounsellingClicked, setCBCounsellingClicked] = useState(false);
    const handleCBCounsellingClicked = () => {
        setCBCounsellingClicked(!cbCounsellingClicked);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
        ...prevState,
        [name]: value,
        }));
    };
  
    const handleAiPromptClicked = () => {
        const applicableAIPrompt = parseInt(formData.counsellingType, 10);
    
        // Map applicableAIPrompt to the corresponding handler function
        const promptHandlers = {
            1: handleStudyAiPromptClicked,
            2: handleJobAiPromptClicked,
            3: handleProductivityPromptClicked,
            4: handleIncrementPromptClicked,
            5: handleJobSavingPromptClicked,
            6: handleFinancialPromptClicked,
            7: handleLifeIssuesPromptClicked,
            8: handleMFIssuesPromptClicked,
            9: handleCBIssuesPromptClicked,
        };
        const handler = promptHandlers[applicableAIPrompt] || handleStudyAiPromptClicked;
        handler();
    };
    

    const handleStudyAiPromptClicked = () => {
        const generatedPrompt = `
        Please analyze the following career assessment form filled out by ${userName}, considering factors such as strengths, weaknesses, and suitability for the student's career goals. Below are the details provided:

        1. Aptitude Test Score: ${formData.aptitudeScore}
        2. Aptitude Test Code: ${formData.aptitudeCode}
        3. Interest Areas: ${formData.interestAreas}
        4. Personality Type: ${formData.personalityType}
        5. Subjects and Marks:
        ${formData.subjects.map(
            (subject) => `  - Subject: ${subject.name}, Marks: ${subject.marks}%`
        ).join("\n")}
        6. Career Goal: ${formData.careerGoal}
        7. Timeline to Achieve Goal (in months): ${formData.timeline}
        8. Key Milestones:
        ${formData.milestones.join("\n")}

        Based on the provided data, please provide the following:
        - An analysis of the ${userName}'s strengths and weaknesses based on the aptitude test score, interest areas, and academic subjects.
        - Suggestions for potential career paths based on the student's personality type and career goal.
        - Advice on how to effectively achieve their career goal considering their timeline and key milestones.
        - Recommendations for improvement and areas to focus on for better performance.
        `;
        
        setFormData((prevState) => ({
        ...prevState,
        aiAssessmentPrompt: generatedPrompt,
        }));

        setAiPromptClicked(!aiPromptClicked);
    };

    const handleJobAiPromptClicked = () => {
        const generatedPrompt = `
        Analyze the following candidate's data filled out by ${userName},:
        - Personality: ${formData.personality}.
        - Education: ${formData.education}.
        - Experience: ${formData.experience}.
        - Skills: ${formData.skills}.
        - Test Scores: ${formData.testScores}.
        Provide a career assessment and suggest suitable career paths, skill improvement areas, and job roles.
        `;
        
        setFormData((prevState) => ({
        ...prevState,
        aiAssessmentPrompt: generatedPrompt,
        }));

        setAiPromptClicked(!aiPromptClicked);
    };

    const handleProductivityPromptClicked = () => {
        const generatedPrompt = `
        Analyze the following productivity-related data filled out by ${userName}:
        - Work Environment: ${formData.workEnvironment}.
        - Daily Routine: ${formData.dailyRoutine}.
        - Time Management: ${formData.timeManagement}.
        - Distractions: ${formData.distractions}.
        - Productivity Goals: ${formData.productivityGoals}.
        Provide an assessment of the current productivity and suggest actionable steps to improve daily efficiency and meet productivity goals.
        `;
    
        setFormData((prevState) => ({
            ...prevState,
            aiAssessmentPrompt: generatedPrompt,
        }));
    
        setAiPromptClicked(!aiPromptClicked);
    };

    const handleIncrementPromptClicked = () => {
        const generatedPrompt = `
        Analyze the following performance-related data filled out by ${userName}:
        - Performance Metrics: ${formData.performanceMetrics}.
        - Feedback Received: ${formData.feedbackReceived}.
        - Skill Gaps: ${formData.skillGaps}.
        - Notable Achievements: ${formData.notableAchievements}.
        - Negotiation Strategy: ${formData.negotiationStrategy}.
        Provide an assessment of the candidate's readiness for an increment and suggest strategies to strengthen their case for a salary increase.
        `;
    
        setFormData((prevState) => ({
            ...prevState,
            aiAssessmentPrompt: generatedPrompt,
        }));
    
        setAiPromptClicked(!aiPromptClicked);
    };
    
    const handleJobSavingPromptClicked = () => {
        const generatedPrompt = `
        Analyze the following job security-related data filled out by ${userName}:
        - Job Security Concerns: ${formData.jobSecurityConcerns}.
        - Performance Issues: ${formData.performanceIssues}.
        - Company Stability: ${formData.companyStability}.
        - Professional Network: ${formData.professionalNetwork}.
        - Contingency Plan: ${formData.contingencyPlan}.
        Provide an assessment of the job security situation and suggest strategies to mitigate risks, improve job performance, and ensure career stability.
        `;
    
        setFormData((prevState) => ({
            ...prevState,
            aiAssessmentPrompt: generatedPrompt,
        }));
    
        setAiPromptClicked(!aiPromptClicked);
    };
    
    const handleFinancialPromptClicked = () => {
        const generatedPrompt = `
        Analyze the following financial data filled out by ${userName}:
        - Monthly Income: ${formData.monthlyIncome}.
        - Monthly Expenses: ${formData.monthlyExpenses}.
        - Savings and Investments: ${formData.savingsAndInvestments}.
        - Debt Management: ${formData.debtManagement}.
        - Financial Goals: ${formData.financialGoals}.
        - Emergency Fund: ${formData.emergencyFund}.
        Provide an assessment of the financial health and suggest steps to improve savings, manage debt, and achieve financial goals.
        `;
    
        setFormData((prevState) => ({
            ...prevState,
            aiAssessmentPrompt: generatedPrompt,
        }));
    
        setAiPromptClicked(!aiPromptClicked);
    };
    
    const handleLifeIssuesPromptClicked = () => {
        const generatedPrompt = `
        Analyze the following life-related data filled out by ${userName}:
        - Stressors: ${formData.stressors}.
        - Work-Life Balance: ${formData.workLifeBalance}.
        - Personal Relationships: ${formData.personalRelationships}.
        - Mental Health: ${formData.mentalHealth}.
        - Coping Mechanisms: ${formData.copingMechanisms}.
        Provide an assessment of the life issues and suggest actionable strategies to manage stress, improve mental health, and achieve a balanced life.
        `;
    
        setFormData((prevState) => ({
            ...prevState,
            aiAssessmentPrompt: generatedPrompt,
        }));
    
        setAiPromptClicked(!aiPromptClicked);
    };
   

    const handleMFIssuesPromptClicked = () => {
        const generatedPrompt = `
        Analyze the following family dynamics and life-related data filled out by ${userName}:
        - Stressors: ${formData.stressors}.
        - Work-Life Balance: ${formData.workLifeBalance}.
        - Personal Relationships: ${formData.personalRelationships}.
        - Mental Health: ${formData.mentalHealth}.
        - Coping Mechanisms: ${formData.copingMechanisms}.
        - Communication Patterns: ${formData.communicationPatterns}.
        - Emotional Connection: ${formData.emotionalConnection}.
        - Conflict Resolution: ${formData.conflictResolution}.
        - Time Priorities: ${formData.timePriorities}.
        - Trust & Respect: ${formData.trustRespect}.
        - Parenting Dynamics: ${formData.parentingDynamics}.
        - Support Systems: ${formData.supportSystems}.
        - Personal Growth & Change: ${formData.personalGrowthChange}.
        
        Provide an assessment of the life issues and family dynamics. Suggest actionable strategies to manage stress, improve relationships, foster emotional connections, and strengthen conflict resolution skills.
        `;
    
        setFormData((prevState) => ({
            ...prevState,
            aiAssessmentPrompt: generatedPrompt,
        }));
    
        setAiPromptClicked(!aiPromptClicked);
    };
    
    const handleCBIssuesPromptClicked = () => {
        const generatedPrompt = `
        Analyze the following child behavior and family-related data filled out by ${userName}:
        - Stressors: ${formData.stressors}.
        - Work-Life Balance: ${formData.workLifeBalance}.
        - Personal Relationships: ${formData.personalRelationships}.
        - Mental Health: ${formData.mentalHealth}.
        - Coping Mechanisms: ${formData.copingMechanisms}.
        - Emotional Expression: ${formData.emotionalExpression}.
        - Behavioral Challenges: ${formData.behavioralChallenges}.
        - Socialization: ${formData.socialization}.
        - Academic Performance: ${formData.academicPerformance}.
        - Family Dynamics: ${formData.familyDynamics}.
        - Sleep Routine: ${formData.sleepRoutine}.
        - Self-Esteem & Confidence: ${formData.selfEsteemConfidence}.
        - Coping Mechanisms: ${formData.copingMechanisms}.
        - Discipline Expectations: ${formData.disciplineExpectations}.
        - Health & Nutrition: ${formData.healthNutrition}.
        
        Provide an assessment of the child's behavior and family dynamics. Suggest actionable strategies to address behavioral challenges, enhance socialization, improve academic performance, and strengthen the family dynamics.
        `;
    
        setFormData((prevState) => ({
            ...prevState,
            aiAssessmentPrompt: generatedPrompt,
        }));
    
        setAiPromptClicked(!aiPromptClicked);
    };
   
    const handleAiAssessmentClicked = async () => {
        if (!formData.aiAssessmentPrompt) {
            alert("Please provide a prompt.");
            return;
        }

        try {
            const config = {
                url: `/chatgpt`,
                method: "post",
                data: { aiAssessmentPrompt: formData.aiAssessmentPrompt },
                headers: { Authorization: authState.token },
            };

            const response = await fetchData(config);
            setChatGPTData(response.message);
            setSaveClicked(true);
        } catch (error) {
            if (error?.response) {
                if (error.response.status === 429) {
                    alert("Rate limit exceeded. Please try again later.");
                } else {
                    alert(`Error: ${errorMessage}`);
                }
            } else if (error?.request) {
                alert("Unable to connect to the server. Please check your internet connection.");
            } else {
                alert("An unexpected error occurred. Please try again.");
            }
        }
    };

    const [psychometricTestsClicked, setPsychometricTestsClicked] = useState(false);
    const handlePsychometricTestsClicked = () => {
        setPsychometricTestsClicked(!psychometricTestsClicked);
    };

    const [aptitudeTestClicked, setAptitudeTestClicked] = useState(false);
    const handleAptitudeTestClicked = () => {
        setAptitudeTestClicked(!aptitudeTestClicked);
    };

    const [trackerClicked, setTrackerClicked] = useState(false);
    const handleTrackerClicked = () => {
        setTrackerClicked(!trackerClicked);
    };

    const [goalClicked, setGoalClicked] = useState(false);
    const handleGoalClicked = () => {
        setGoalClicked(!goalClicked);
    };

    const [rcaClicked, setRCAClicked] = useState(false);
    const handleRCAClicked = () => {
        setRCAClicked(!rcaClicked);
    };

    const handleBookCouncellor = () => {
        navigate("/think5whys-counsellors")
    };

    const handleSaveAIAssessment = async () => {
        const updatedFormData = {
            ...formData,
            counsellorName: counsellorName, 
        };

        setFormData(updatedFormData); 
        try {
            const config = {
                url: `/aicounselling/save`,
                method: "post",
                data: updatedFormData,
                headers: { Authorization: authState.token },
            };
    
            const response = await fetchData(config);
            setSaved(true); 
            setSaveClicked(true);
        } catch (error) {
            console.error('An error occurred while saving the AI assessment:', error);
        }
    };

    const handlePayNow = () => {
        setPayNowClicked(true);
    };
    
    const handleViewPocket = () => {
        setViewPocketClicked(true);
        navigate('/wallet-mypocket');
    };

    const handleClaimNow = () => {
        fetchClaimNow();
    };

    const fetchClaimNow = async () => {
        try {
            const config = {
                url: `/pocket/createbokcreditdata`,
                method: "post",
                data: {userId: userId, dateCreated: new Date()},
                headers: { Authorization: authState.token },
            };
            const response = await fetchData(config);
            if(response.status===true){
                // console.log("---- ",response);

                setClaimed(true);
                setRcaCreditStatus(true);
            } 
            setClaimClicked(true);
        } catch (error) {
            console.error('An error occurred while claiming the credit:', error);
        }
    };
    
    const handleRechargePocket = () => {
        navigate('/wallet-pockettransfer', { state: { title: "AI Counselling", paymentAmount: formData.paymentAmount - pocketBalanceAmount, gifterId: authState.user._id, gifterName: authState.user.name, giftFor: "", giftMessage: "", gifterSignatureLine: "" } });
    };

    const pocketPaymentClicked = (orderNumber, purchaseDate) => {
        setInvoice(`
            <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; border: 1px solid #ddd; padding: 20px; border-radius: 10px;">
                <h2 style="font-size: 24px; font-weight: 600; color: #333; margin-bottom: 20px; text-align: center;">Order Summary</h2>
                <div style="color: #555; line-height: 1.6;">
                    <p><strong>Order Number:</strong> ${orderNumber}</p>
                    <p><strong>Order Date:</strong> ${purchaseDate.toLocaleString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', timeZoneName: 'short' })}</p>
                    <p><strong>Customer Name:</strong> ${userName}</p>
                    <p><strong>Customer Address:</strong> Online Digital Product</p>
                    <p><strong>Item:</strong> ${selectedAICounsellingOption}</p>
                    <p><strong>Item Description:</strong> ${"AI Counselling"}</p>
                    <p><strong>HSN Code:</strong> ${"999293"}</p>
                    <p><strong>GST Rate:</strong> ${18.00}</p>
                    <p><strong>Qty:</strong> 1 </p>
                    <p><strong>Rate:</strong> ₹${formData.paymentAmount}</p>
                    <p><strong>Bill Amount:</strong> ₹${formData.paymentAmount}</p>
                    <p><strong>Amount Paid:</strong> ₹${formData.paymentAmount}</p>
                    <p><strong>Payment Method:</strong>{'Digital through Think5Whys Prepaid Pocket'}</p>
                    <p><strong>Terms & Conditions:</strong> ${"No refund will be made in any circumstances."}</p>
                    </div>
            </div>
        `);
        setPaymentConfirmClicked(true);
    };

    //PocketBalance
    const fetchPocketBalance = useCallback(() => {
        const config = {
            url: "/pocketbalance/my",
            method: "post",
            headers: { Authorization: authState.token },
            data: {userId: userId}
        };

        fetchData(config, { showSuccessToast: false })
        .then(response => {
            // console.log("Pocket Balance Response:", response);

            // Ensure the response contains the expected structure
            if (response.status && response.pocketBalance) {
                const { balanceAmount, lastTransactionDate, remarks } = response.pocketBalance;

                // Update the state with the fetched data
                setPocketBalanceAmount(balanceAmount || 0.0);
                setPocketLastUpdated(lastTransactionDate || null);
                setPocketLastUpdatedRemarks(remarks || "No remarks available");
            } else {
                console.error("Invalid response format:", response);
                setPocketBalanceAmount(0.0);
                setPocketLastUpdated(null);
                setPocketLastUpdatedRemarks("Record Not Available!");
            }
        })
        .catch(error => {
            console.error("Error fetching pocket balance:", error);
            setPocketBalanceAmount(0.0);
            setPocketLastUpdated(null);
            setPocketLastUpdatedRemarks("Error fetching data");
        });
    }, [authState.token, fetchData]);

    useEffect(() => {
        if (!authState.isLoggedIn) return;
        fetchPocketBalance();
    }, [authState.isLoggedIn, fetchPocketBalance]);

    const counsellorCodeValidationClicked = () => {
        setCounsellorCodeButtonClicked(true);
        if (formData.myCounsellor=='') {
            setError("Counsellor Code is required!!");
            return;
        }
        fetchCounsellor(formData.myCounsellor);
    };

    const fetchCounsellor = useCallback((counsellorCode) => {
      const config = {
          url: "/auth/verifyreferralcode",
          method: "post",
          headers: { Authorization: authState.token },
          data: { think5whyscode: counsellorCode }
      };
    
      fetchData(config)
          .then(response => {
              if (response && response.status) {
                  setCounsellorCodeStatus(true);

                  setCounsellorId(response.t5wcode._id);
                  setCounsellorName(response.t5wcode.name);
                  setCounsellorCodeStatusMsg("Counsellor Code found. 😊");
                  setFormData((prevFormData) => ({
                    ...prevFormData, 
                    counsellorName: response.t5wcode.name, 
                }));
              } else {
                  // console.log("Counsellor Code Not found");
                  setCounsellorCodeStatus(false);
                  setCounsellorCodeStatusMsg(`Counsellor Code ${counsellorCode} not found! 😔 Make sure the Counsellor Code is valid.`);
              }
          })
          .catch(error => {
              // console.log("Counsellor Code Not found!", error);
              setCounsellorCodeStatus(false);
              setCounsellorCodeStatusMsg("Error in getting data");
          });
    }, [fetchData, authState.token, setCounsellorCodeStatus, setCounsellorId, setCounsellorName, setCounsellorCodeStatusMsg]);
    
    
    useEffect(() => {
      if (!authState.isLoggedIn) return;
    }, [authState.isLoggedIn, fetchCounsellor]);

  return (
    // <MainLayout>
    <div className="py-4 px-4 flex flex-col justify-center bg-black">
      <header
        className="
            sticky top-0 z-50 
            bg-black 
            px-4 py-3 
            flex flex-col items-center justify-center
            shadow-md border-b border-gray-800
        "
        >
        <div className="flex flex-row gap-2 items-center justify-left">
            
            <img
            src={AICounsellingImage}
            alt="MyProfile Image"
            style={{ height: "100px" }}
            className="rounded-lg shadow-lg"
            />

            <div className="mt-2">
                <h1 className="text-xl lg:text-2xl ml-4 text-yellow-200 mt-1">
                    Think5Whys AI Counsellor
                </h1>
            </div>

        </div>
    </header>

      <div className='py-2 px-4 mb-2 text-sm border-2 border-red-500 bg-black rounded-md'>
        <div className="flex flex-col radio-group py-2 px-4 justify-center items-center">
            <div className="flex flex-row items-center gap-1 bg-blue-700 border border-blue-400 p-2 mb-2 rounded-md">
                <Link
                    to="/aicounselling-about"
                    className="flex items-center justify-center w-5 h-5 lg:w-7 lg:h-7 rounded-full bg-green-600 hover:scale-105 transition-transform"
                >
                    <FontAwesomeIcon
                    icon={faQuestionCircle}
                    className="text-yellow-300 text-lg"
                    />
                </Link>
                <span className="text-sm lg:text-m text-gray-200 mt-1 font-bold">About</span>
            </div>

            <strong className="text-yellow-200 text-m">Select Counselling Type You Want To Go With</strong>

            <div className="grid grid-cols-2 lg:grid-cols-6 gap-1 gay-y-0 w-full">
                {counsellingOptions.map((option) => (
                <label
                    key={option.value}
                    className={`
                    w-full 
                    flex items-center justify-center 
                    px-4 py-3 
                    border rounded-md shadow-sm cursor-pointer 
                    text-center
                    transition-all duration-300 
                    hover:bg-blue-600 
                    ${
                        formData.counsellingType === option.value
                        ? "bg-blue-500 text-white border-blue-600"
                        : "bg-black text-white border-gray-300"
                    }
                    `}
                >
                    <i className={`${option.icon} text-xl mr-2`}></i>

                    <input
                    type="radio"
                    name="counsellingType"
                    value={option.value}
                    checked={formData.counsellingType === option.value}
                    onChange={(e) =>
                        setFormData({
                        ...formData,
                        counsellingType: e.target.value,
                        })
                    }
                    className="hidden"
                    />

                    <span className="font-medium">{option.label}</span>
                </label>
                ))}
            </div>
        </div>
    </div>
    <div className='py-4 px-4 mt-2 mb-2 text-sm border-2 border-purple-700 rounded-md'>
        <div className="flex flex-col items-center border rounded-lg p-4 shadow-md bg-gray-800 mb-4">
            <p className="text-yellow-200 text-sm">Think5Whys Main BOK Status: {rcaBookStatus ? "Purchased": "Not Purchased Yet"}</p>
            <p className="text-white text-sm">{rcaCreditStatus ? "Credited Rs. 300.00 into ThinkAIInsight Pocket": "Rs. 300.00 Not Claimed Yet!"}</p>
            {!rcaCreditStatus && ( 
                <button
                onClick={handleClaimNow}
                disabled={saveClicked || claimed}
                className={"think5whys-button mt-4 px-2 py-2 rounded-lg text-m transition-all duration-300 ease-in-out"}
            >
                Claim Now
            </button>
            )} 
        </div> 
        <div className="flex flex-col items-center border rounded-lg p-4 shadow-md bg-gray-800 mb-4">
            <p className="text-yellow-200 text-sm">Think5Whys Main BOK Status: {rcaBookStatus ? "Purchased": "Not Purchased Yet"}</p>
            <p className="text-white text-sm">{rcaCreditStatus ? "Credited Rs. 300.00 into ThinkAIInsight Pocket": "Rs. 300.00 Not Claimed Yet!"}</p>
            {!rcaCreditStatus && ( 
                <button
                onClick={handleClaimNow}
                disabled={saveClicked || claimed}
                className={"think5whys-button mt-4 px-2 py-2 rounded-lg text-m transition-all duration-300 ease-in-out"}
            >
                Claim Now
            </button>
            )} 
        </div>        
        <div className='text-center py-2 text-white bg-blue-600 rounded-md mt-2 mb-2'>Select option from below. The amount will be charged from Your ThinkAIInsight Pocket </div>
            <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4 w-full">
                {[
                    { label: 'Plan 1 - COT - Cost of Tiny Chocolate (Rs. 5.90)', icon: 'fa-solid fa-calculator' },
                    { label: 'Paln 2 - COB - Cost of Biscuits (Rs. 11.80)', icon: 'fa-solid fa-cogs' },
                    { label: 'Plan 3 - COS - Cost of Samosa (Rs. 17.70)', icon: 'fa-solid fa-cogs' },
                    { label: 'Plan 4 - DeepThinker (Rs. 29.50)', icon: 'fa-solid fa-brain' },
                ].map((option, index) => (
                    <div
                    key={index}
                    className={`flex flex-col items-center justify-center p-6 rounded-lg border border-blue-400 transition-all duration-300 ease-in-out w-full text-center
                        ${selectedAICounsellingOption === option.label
                        ? 'bg-blue-600 text-white font-semibold'
                        : 'bg-black hover:bg-blue-500 hover:text-white cursor-pointer'
                        }`}
                    onClick={() => {
                        setSelectedAICounsellingOption(option.label);
                        setFormData({
                        ...formData,
                        paymentAmount: [5.90, 11.80, 17.70, 29.50][index],
                        item: option.label,
                        selectedPlan: index,
                        });
                    }}
                    >
                    <i className={`${option.icon} text-white text-xl mb-2`}></i>
                    <span className="text-sm text-white">{option.label}</span>
                    </div>
                ))}
        </div>
        <div className="flex flex-row justify-center text-center mt-2">
            <button
                onClick={handlePayNow}
                disabled={!selectedAICounsellingOption || saveClicked}
                className={`w-full think5whys-button rounded-lg text-sm lg:text-m py-4 transition-all duration-300 ease-in-out ${
                !selectedAICounsellingOption
                    ? 'bg-gray-400 text-gray-700 cursor-not-allowed'
                    : 'bg-blue-600 text-white hover:bg-blue-700'
                }`}
            >
                Plan You Selected: {formData.selectedPlan + 1}{'. Proceed to '}
                {selectedAICounsellingOption
                ? `Pay Rs. ${formData.paymentAmount.toFixed(2)}`
                : 'Select an Option to Pay'}
                {' '} including GST
            </button>
        </div>

        <div className='w-full flex justify-center text-m text-yellow-200'>ThinkAIInsight Pocket Balance Amount (Rs.): {pocketBalanceAmount.toFixed(2)}</div>
        <div className='flex flex-col justify-center ml-4 mt-4'>
            <button onClick={handleViewPocket} className='think5whys-button mt-4 px-2 py-2 rounded-lg text-m transition-all duration-300 ease-in-out'>View Pocket History</button>
            {pocketBalanceAmount <1 && (
                <button onClick={handleRechargePocket} className='think5whys-button mt-4 px-2 py-2 rounded-lg text-m transition-all duration-300 ease-in-out'>Refill Pocket</button>
            )}
        </div>
        {payNowClicked && (
          <div className="details-container w-full sm:w-11/12 md:w-10/12 lg:w-8/12 xl:w-7/12 mx-auto text-white bg-black border border-blue-400  rounded-lg shadow-lg p-4 mb-2">
            <div className="mb-2">
              <div className="mb-4 text-lg text-white">
                <p>Price to pay: <span className='text-yellow-300'>₹{formData.paymentAmount.toFixed(2)}</span></p>
                <p>ThinkAIInsight Pocket Balance: <span className='text-yellow-300'>₹{pocketBalanceAmount.toFixed(2)}</span></p>
                {formData.paymentAmount > pocketBalanceAmount ? (
                  <p className="text-red-500">Insufficient Balance by: ₹{(formData.paymentAmount - pocketBalanceAmount).toFixed(2)}</p>
                ) : (
                  <p className="text-white">
                    After payment your Think5Whys Purse / Pocket balance will be: <span className='text-yellow-300'>₹{(pocketBalanceAmount - formData.paymentAmount).toFixed(2)}</span>
                  </p>
                )}
              </div>
            </div>

            {pocketBalanceAmount < formData.paymentAmount && (
              <div className='mb-4 flex justify-center'>
                <button 
                  type="button" 
                  className="block w-full md:w-auto bg-blue-800 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark" 
                  onClick={handleRechargePocket}
                >
                  Make Payment then Return Back to complete the Process
                </button>
              </div>
            )}

            {pocketBalanceAmount >= formData.paymentAmount && (
              <div className="flex flex-col p-6 border-2 border-yellow-400 rounded-lg shadow-lg bg-black max-w-md mx-auto my-4">
                <h2 className="text-2xl font-semibold text-yellow-200 mb-4 text-center">Order Summary</h2>
                <div className="space-y-2 text-white">
                  <p><strong>Order Number:</strong> {orderNumber}</p>
                  <p><strong>Order Date:</strong> {purchaseDate.toLocaleString('en-US', {
                    weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', timeZoneName: 'short'
                  })}</p>
                  <p><strong>Customer Name:</strong> {customerName}</p>
                  <p><strong>Customer Address:</strong> Online Digital Product</p>
                  <p><strong>Item:</strong> {selectedAICounsellingOption}</p>
                  <p><strong>Item Description:</strong> {"Think5Whys AI Counselling with Prompt"}</p>
                  <p className="text-lg font-bold text-green-400"><strong>Price To Pay:</strong> ₹{formData.paymentAmount}</p>
                  <p className="text-lg font-bold text-green-400"><strong>Payment Amount:</strong> ₹{formData.paymentAmount}</p>
                  <p><strong>Payment Date:</strong> {purchaseDate.toLocaleString('en-US', {
                    weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', timeZoneName: 'short'
                  })}</p>
                </div>
                <div className="flex justify-center mt-6">
                  <button
                    type="button"
                    className={`${
                        paymentConfirmClicked ? "bg-orange-500 hover:bg-orange-700" : "bg-green-500 hover:bg-green-700"
                      } text-white py-2 px-6 rounded-md font-medium transition duration-300 ease-in-out`}
                    disabled={saveClicked || paymentConfirmClicked}
                    onClick={() => pocketPaymentClicked(orderNumber, purchaseDate)}
                  >
                    {paymentConfirmClicked ? 
                        "You Confirmed To Buy. Your ThinkAIInsight Pocket is being Deducted." : 
                        "Confirm Now To Buy. Your ThinkAIInsight Pocket Will Be Deducted."
                    }
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      <div className="section mb-2 px-6 py-6 border-2 border-yellow-400 rounded-md shadow-lg bg-black text-white" id="psychometric-tests">
        <div className="flex flex-row justify-center">
            <button
                type="button"
                className="bg-blue-500 text-white py-2 px-6 rounded-md font-medium hover:bg-blue-700 transition duration-300 ease-in-out"
                onClick={() => viewAICounsellingHistorytClicked()}
                >
                Counselling History
            </button>
            <button
                type="button"
                className="bg-blue-500 text-white ml-4 py-2 px-6 rounded-md font-medium hover:bg-blue-700 transition duration-300 ease-in-out"
                onClick={() => viewPersonalCounsellingHistoryClicked()}
                >
                Counsellor History
            </button>
        </div>
      </div>

    {/* Study Counselling */}
    {parseInt(formData.counsellingType, 10) === 1 && (
      <div className="section border-2 border-red-300 rounded-lg shadow-lg px-6 py-6 bg-black text-white" id="psychometric-tests">
        <button 
            type="button"
            onClick={handleStudyCounsellingClicked}
            className="text-m font-bold mb-4"
        >
            Regular Study / Career Counselling
        </button>
        { studyCounsellingClicked && (
            <>
            {/* Psychometric Tests */}
            <div className="section px-6 py-6 border-2 border-purple-700 rounded-md shadow-lg bg-black text-white" id="psychometric-tests">
                <button 
                    type="button"
                    onClick={handlePsychometricTestsClicked}
                    className="text-lg font-bold mb-4 bg-blue-500"
                >
                    1. Psychometric Tests
                </button>
                {psychometricTestsClicked && (
                    <>
                    {categories.map((category, categoryIndex) => {
                        let questionNumber = 1;

                        return (
                            <div
                                key={categoryIndex}
                                className="category-section mb-2 p-6 bg-white shadow-lg rounded-xl border border-gray-300"
                            >
                                <p className="text-sm font-bold text-gray-800 mb-2">{category}</p>

                                {questions[category].map((question, questionIndex) => (
                                    <ol key={questionIndex} className="list-decimal pl-2">
                                        <div className="question-section mb-2">
                                            <p className="text-sm text-gray-700 mb-1">
                                                <span className="font-semibold text-gray-900">
                                                    {questionNumber++}.
                                                </span>{" "}
                                                {question}
                                            </p>

                                        {options[question].map((option, optionIndex) => (
                                                <div
                                                    key={optionIndex}
                                                    className="option-container pl-4 flex items-center hover:bg-gray-100 rounded-lg transition-all duration-200 p-0"
                                                >
                                                    <input
                                                        type="radio"
                                                        id={`category-${categoryIndex}-question-${questionIndex}-option-${optionIndex}`}
                                                        name={`category-${categoryIndex}-question-${questionIndex}`}
                                                        value={option}
                                                        onChange={() => handleOptionChange(category, question, option)}
                                                        checked={formData.psychometric.some(
                                                            (item) =>
                                                                item.category === category &&
                                                                item.questions?.some(
                                                                    (q) => q.question === question && q.selectedOption === option
                                                                )
                                                        )}
                                                        className="mr-4 w-4 h-4 accent-blue-500"
                                                    />
                                                    <label
                                                        htmlFor={`category-${categoryIndex}-question-${questionIndex}-option-${optionIndex}`}
                                                        className="text-gray-800 text-sm cursor-pointer select-none"
                                                    >
                                                        {option}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    </ol>
                                ))}
                            </div>
                        );
                    })}
                    </>
                )}
            </div>

            {/* Aptitude Tests */}
            <div className="px-6 py-6 border-2 border-purple-400 rounded-md shadow-lg bg-black text-white" id="psychometric-tests">
                <button 
                    type="button"
                    onClick={handleAptitudeTestClicked}
                    className="text-m font-bold mb-4 bg-blue-500"
                >
                    2. Aptitude Tests
                </button>
                {aptitudeTestClicked && (
                    <div className="form-group grid gap-4">
                        <div className="flex flex-col">
                        <label htmlFor="aptitude-score" className="mb-2 font-semibold">Aptitude Test Score:</label>
                        <input
                            type="number"
                            id="aptitude-score"
                            name="aptitudeScore"
                            min={1}
                            max={100}
                            style={{ width: "100px" }}
                            className="w-32 px-4 py-2 border-2 border-white rounded-md text-black"
                            value={formData.aptitudeScore}
                            onChange={handleInputChange}
                        />
                        </div>
                        <div className="flex flex-col">
                        <label htmlFor="aptitude-code" className="mb-2 font-semibold">Thin5Whys Aptitude Test Code:</label>
                        <span className="text-sm text-yellow-300">(Provide more than one code separated by a comma ,)</span>
                        <input
                            type="text"
                            id="aptitude-code"
                            name="aptitudeCode"
                            className="w-full px-4 py-2 border-2 border-white rounded-md text-black"
                            value={formData.aptitudeCode}
                            disabled={formData.selectedPlan===0}
                            onChange={handleInputChange}
                        />
                        </div>
                        <button
                        type="button"
                        onClick={handlePullMockTestData}
                        disabled={saveClicked || formData.selectedPlan===0}
                        className="w-full px-6 py-3 bg-yellow-400 hover:bg-yellow-500 text-black font-semibold rounded-lg transition-all duration-300"
                        >
                        Pull Data From Think5Whys Mock Tests
                        </button>
                        <div className="flex flex-col">
                        <label htmlFor="interest-areas" className="mb-2 font-semibold">Interest Areas:</label>
                        <input
                            type="text"
                            id="interest-areas"
                            name="interestAreas"
                            placeholder="Your interests..."
                            className="w-full px-4 py-2 bg-gray-100 text-black border-2 border-white rounded-md"
                            value={formData.interestAreas}
                            onChange={handleInputChange}
                        />
                        </div>
                        <div className="flex flex-col">
                        <label htmlFor="personality-type" className="mb-2 font-semibold">Personality Type:</label>
                        <select
                            id="personality-type"
                            name="personalityType"
                            className="h-12 w-64 px-4 py-2 border-2 border-white rounded-md bg-gray-100 text-black"
                            value={formData.personalityType}
                            style={{width: "250px"}}
                            onChange={handleInputChange}
                        >
                            <option value="" disabled>Select your personality type</option>
                            <option value="adaptive-learner">Adaptive Learner</option>
                            <option value="adventurous">Adventurous Learner</option>
                            <option value="ambivert">Ambivert</option>
                            <option value="analytical-thinker">Analytical Thinker</option>
                            <option value="creative">Creative/Innovative</option>
                            <option value="empathetic">Empathetic/Supportive</option>
                            <option value="extrovert">Extrovert</option>
                            <option value="goal-oriented">Goal-Oriented</option>
                            <option value="idealistic">Idealistic Learner</option>
                            <option value="independent-learner">Independent Learner</option>
                            <option value="introvert">Introvert</option>
                            <option value="observant">Passive/Observant</option>
                            <option value="perfectionist">Perfectionist</option>
                            <option value="practical">Practical/Realistic</option>
                            <option value="procrastinator">Procrastinator</option>
                            <option value="social-learner">Social Learner</option>
                            <option value="strategic-planner">Strategic Planner</option>
                        </select>
                        </div>
                    </div>
                )}
            </div>

            {/* Academic Data Analysis */}
            <div className="section border-2 border-green-300 rounded-lg shadow-lg px-6 py-6 bg-black text-white" id="academic-data-analysis">
                <button 
                    type="button"
                    onClick={handleTrackerClicked}
                    className="text-m font-bold mb-4 bg-blue-500"
                >
                    3. Academic Career Tracker / Data Analysis
                </button>
                { trackerClicked && (
                    <>
                    <div className="form-group mb-6">
                        <label htmlFor="examTitle" className="block text-sm font-semibold mb-2">Academic Exam Title:</label>
                        <input
                        type="text"
                        id="examTitle"
                        name="examTitle"
                        placeholder="Your exam title..."
                        className="w-full max-w-md px-4 py-2 border-2 border-white rounded-md bg-gray-100 text-black"
                        value={formData.examTitle}
                        onChange={handleInputChange}
                        />
                    </div>
                    
                    <div className="form-group mb-2">
                        <label className="block text-sm font-semibold mb-2">Subject Name and % Marks:</label>
                        {formData.subjects.map((subject, index) => (
                        <div key={index} className="subject-entry flex flex-wrap gap-4 items-center mb-4">
                            <select
                            value={subject.name || ""}
                            onChange={(e) => handleSubjectChange(index, e.target.value)}
                            className="h-12 px-4 py-2 border-2 border-white rounded-md bg-gray-100 text-black"
                            style={{ width: "200px" }}
                            >
                            <option value="" disabled>Select Subject</option>
                            {cbseSubjects.map((subjectName, idx) => (
                                <option key={idx} value={subjectName}>{subjectName}</option>
                            ))}
                            </select>
                            <input
                            type="number"
                            placeholder="Percentage Marks"
                            min={1}
                            max={100}
                            value={subject.marks}
                            onChange={(e) => handleMarksChange(index, e.target.value)}
                            className="h-12 px-4 py-2 border-2 border-white rounded-md bg-gray-100 text-black"
                            style={{ width: "100px" }}
                            />
                            <button
                            type="button"
                            onClick={() => handleRemoveSubject(index)}
                            style={{ width: "100px" }}
                            className="px-4 py-2 bg-red-400 hover:bg-red-500 text-white font-semibold rounded-lg transition-all duration-300"
                            >
                            Remove
                            </button>
                        </div>
                        ))}
                        {availableSubjects.length > 0 && (
                        <button
                            type="button"
                            onClick={handleAddSubject}
                            className="px-6 py-3 bg-blue-400 hover:bg-blue-500 text-white font-semibold rounded-lg transition-all duration-300"
                        >
                            Add Subject
                        </button>
                        )}
                    </div>

                    <div className="form-group mb-2">
                        <label className="block text-sm font-semibold mb-2">Your strongest subject: <span className="font-normal">{strongestSubject || "None"}</span></label>
                        <label className="block text-sm font-semibold mb-2">Your weakest subject: <span className="font-normal">{weakestSubject || "None"}</span></label>
                    </div>

                    <div className="form-group mb-2">
                        <label htmlFor="academicDataCode" className="block text-sm font-semibold mb-2">Academic Data Code:</label>
                        <input
                        type="text"
                        id="academicDataCode"
                        name="academicDataCode"
                        className="w-full max-w-md px-4 py-2 border-2 border-white rounded-md bg-gray-100 text-black"
                        value={formData.academicDataCode}
                        disabled={formData.selectedPlan===0}
                        onChange={handleInputChange}
                        />
                    </div>

                    <button
                        type="button"
                        onClick={handlePullAcademicData}
                        disabled={saveClicked || formData.selectedPlan===0}
                        className="w-full max-w-lg px-6 py-3 bg-yellow-400 hover:bg-yellow-500 text-black font-semibold rounded-lg transition-all duration-300"
                    >
                        Pull Data From Think5Whys Academic Tracker
                    </button>
                    </>
                )}
            </div>
            </>
        )}
        </div>
    )}

    {/* Job Search Counselling */}
    {parseInt(formData.counsellingType, 10) === 2 && (
        <div className="section border-2 border-red-300 rounded-lg shadow-lg px-6 py-6 bg-black text-white" id="psychometric-tests">
            <button 
                type="button"
                onClick={handleJobSearchCounsellingClicked}
                className="text-m font-bold mb-4"
            >
                Job Search Counselling
            </button>
            { jobSearchCounsellingClicked && (
                <>
                <div className="form-group mt-4 space-y-6 sm:space-y-8">
                    <div>
                        <label htmlFor="personality" className="block text-sm font-medium text-white">Personality:</label>
                        <input
                            type="text"
                            id="personality"
                            name="personality"
                            className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                            value={formData.personality}
                            disabled={formData.selectedPlan===0}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div>
                        <label htmlFor="education" className="block text-sm font-medium text-white">Education:</label>
                        <input
                            type="text"
                            id="education"
                            name="education"
                            className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                            value={formData.education}
                            disabled={formData.selectedPlan===0}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div>
                        <label htmlFor="experience" className="block text-sm font-medium text-white">Experience:</label>
                        <input
                            type="text"
                            id="experience"
                            name="experience"
                            className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                            value={formData.experience}
                            disabled={formData.selectedPlan===0}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div>
                        <label htmlFor="skills" className="block text-sm font-medium text-white">Skills:</label>
                        <input
                            type="text"
                            id="skills"
                            name="skills"
                            className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                            value={formData.skills}
                            disabled={formData.selectedPlan===0}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div>
                        <label htmlFor="testScores" className="block text-sm font-medium text-white">Test Scores:</label>
                        <input
                            type="text"
                            id="testScores"
                            name="testScores"
                            className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                            value={formData.testScores}
                            disabled={formData.selectedPlan===0}
                            onChange={handleInputChange}
                        />
                    </div>
                </div>
                </>
            )}
        </div>
    )}

    {/* Productivity Counselling */}
    {parseInt(formData.counsellingType, 10) === 3 && (
        <div className="section border-2 border-green-300 rounded-lg shadow-lg px-6 py-6 bg-black text-white" id="psychometric-tests">
            <button 
                type="button"
                onClick={handlePISearchCounsellingClicked}
                className="text-m font-bold mb-4"
            >
                Productivity Increase Counselling
            </button>
            { piSearchCounsellingClicked && (
                <>
                <div className="form-group mt-4 space-y-6 sm:space-y-8">
                    <div>
                        <label htmlFor="workEnvironment" className="block text-sm font-medium text-white">Work Environment:</label>
                        <input
                            type="text"
                            id="workEnvironment"
                            name="workEnvironment"
                            className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                            value={formData.workEnvironment}
                            disabled={formData.selectedPlan===0}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div>
                        <label htmlFor="dailyRoutine" className="block text-sm font-medium text-white">Daily Routine:</label>
                        <input
                            type="text"
                            id="dailyRoutine"
                            name="dailyRoutine"
                            className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                            value={formData.dailyRoutine}
                            disabled={formData.selectedPlan===0}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div>
                        <label htmlFor="timeManagement" className="block text-sm font-medium text-white">Time Management:</label>
                        <input
                            type="text"
                            id="timeManagement"
                            name="timeManagement"
                            className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                            value={formData.timeManagement}
                            disabled={formData.selectedPlan===0}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div>
                        <label htmlFor="distractions" className="block text-sm font-medium text-white">Distractions:</label>
                        <input
                            type="text"
                            id="distractions"
                            name="distractions"
                            className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                            value={formData.distractions}
                            disabled={formData.selectedPlan===0}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div>
                        <label htmlFor="productivityGoals" className="block text-sm font-medium text-white">Productivity Goals:</label>
                        <input
                            type="text"
                            id="productivityGoals"
                            name="productivityGoals"
                            className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                            value={formData.productivityGoals}
                            disabled={formData.selectedPlan===0}
                            onChange={handleInputChange}
                        />
                    </div>
                </div>
                </>
            )}
        </div>
    )}


    {/* Increment Counselling */}
    {parseInt(formData.counsellingType, 10) === 4 && (
        <div className="section border-2 border-red-300 rounded-lg shadow-lg px-6 py-6 bg-black text-white" id="psychometric-tests">
            <button 
                type="button"
                onClick={handleIFSearchCounsellingClicked}
                className="text-m font-bold mb-4"
            >
                Increment Focus Counselling
            </button>
            { ifSearchCounsellingClicked && (
                <>
                <div className="form-group mt-4 space-y-6 sm:space-y-8">
                    <div>
                        <label htmlFor="performanceMetrics" className="block text-sm font-medium text-white">Performance Metrics:</label>
                        <input
                            type="text"
                            id="performanceMetrics"
                            name="performanceMetrics"
                            className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                            value={formData.performanceMetrics}
                            disabled={formData.selectedPlan===0}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div>
                        <label htmlFor="feedbackReceived" className="block text-sm font-medium text-white">Feedback Received:</label>
                        <input
                            type="text"
                            id="feedbackReceived"
                            name="feedbackReceived"
                            className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                            value={formData.feedbackReceived}
                            disabled={formData.selectedPlan===0}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div>
                        <label htmlFor="skillGaps" className="block text-sm font-medium text-white">Skill Gaps:</label>
                        <input
                            type="text"
                            id="skillGaps"
                            name="skillGaps"
                            className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                            value={formData.skillGaps}
                            disabled={formData.selectedPlan===0}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div>
                        <label htmlFor="notableAchievements" className="block text-sm font-medium text-white">Notable Achievements:</label>
                        <input
                            type="text"
                            id="notableAchievements"
                            name="notableAchievements"
                            className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                            value={formData.notableAchievements}
                            disabled={formData.selectedPlan===0}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div>
                        <label htmlFor="negotiationStrategy" className="block text-sm font-medium text-white">Negotiation Strategy:</label>
                        <input
                            type="text"
                            id="negotiationStrategy"
                            name="negotiationStrategy"
                            className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                            value={formData.negotiationStrategy}
                            disabled={formData.selectedPlan===0}
                            onChange={handleInputChange}
                        />
                    </div>
                </div>
                </>
            )}
        </div>
    )}

    {/* Job Saving Counselling */}
    {parseInt(formData.counsellingType, 10) === 5 && (
        <div className="section border-2 border-green-300 rounded-lg shadow-lg px-6 py-6 bg-black text-white" id="psychometric-tests">
            <button 
                type="button"
                onClick={handleJobSavingCounsellingClicked}
                className="text-m font-bold mb-4"
            >
                Job Saving / Job Risk Mitigation Counselling
            </button>
            { jobSavingCounsellingClicked && (
                <>
                <div className="form-group mt-4 space-y-6 sm:space-y-8">
                    <div>
                        <label htmlFor="jobSecurityConcerns" className="block text-sm font-medium text-white">Job Security Concerns:</label>
                        <input
                            type="text"
                            id="jobSecurityConcerns"
                            name="jobSecurityConcerns"
                            className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                            value={formData.jobSecurityConcerns}
                            disabled={formData.selectedPlan===0}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div>
                        <label htmlFor="performanceIssues" className="block text-sm font-medium text-white">Performance Issues:</label>
                        <input
                            type="text"
                            id="performanceIssues"
                            name="performanceIssues"
                            className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                            value={formData.performanceIssues}
                            disabled={formData.selectedPlan===0}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div>
                        <label htmlFor="companyStability" className="block text-sm font-medium text-white">Company Stability:</label>
                        <input
                            type="text"
                            id="companyStability"
                            name="companyStability"
                            className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                            value={formData.companyStability}
                            disabled={formData.selectedPlan===0}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div>
                        <label htmlFor="professionalNetwork" className="block text-sm font-medium text-white">Professional Network:</label>
                        <input
                            type="text"
                            id="professionalNetwork"
                            name="professionalNetwork"
                            className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                            value={formData.professionalNetwork}
                            disabled={formData.selectedPlan===0}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div>
                        <label htmlFor="contingencyPlan" className="block text-sm font-medium text-white">Contingency Plan:</label>
                        <input
                            type="text"
                            id="contingencyPlan"
                            name="contingencyPlan"
                            className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                            value={formData.contingencyPlan}
                            disabled={formData.selectedPlan===0}
                            onChange={handleInputChange}
                        />
                    </div>
                </div>
                </>
            )}
        </div>
    )}

    {/* Financial Counselling */}
    {parseInt(formData.counsellingType, 10) === 6 && (
        <div className="section border-2 border-red-300 rounded-lg shadow-lg px-6 py-6 bg-black text-white" id="psychometric-tests">
            <button 
                type="button"
                onClick={handleFinancialCounsellingClicked}
                className="text-m font-bold mb-4"
            >
                Financial Counselling
            </button>
            { financialCounsellingClicked && (
                <>
                <div className="form-group mt-4 space-y-6 sm:space-y-8">
                    <div>
                        <label htmlFor="monthlyIncome" className="block text-sm font-medium text-white">Monthly Income:</label>
                        <input
                            type="text"
                            id="monthlyIncome"
                            name="monthlyIncome"
                            className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                            value={formData.monthlyIncome}
                            disabled={formData.selectedPlan===0}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div>
                        <label htmlFor="monthlyExpenses" className="block text-sm font-medium text-white">Monthly Expenses:</label>
                        <input
                            type="text"
                            id="monthlyExpenses"
                            name="monthlyExpenses"
                            className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                            value={formData.monthlyExpenses}
                            disabled={formData.selectedPlan===0}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div>
                        <label htmlFor="savingsAndInvestments" className="block text-sm font-medium text-white">Savings & Investments:</label>
                        <input
                            type="text"
                            id="savingsAndInvestments"
                            name="savingsAndInvestments"
                            className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                            value={formData.savingsAndInvestments}
                            disabled={formData.selectedPlan===0}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div>
                        <label htmlFor="debtManagement" className="block text-sm font-medium text-white">Debt Management:</label>
                        <input
                            type="text"
                            id="debtManagement"
                            name="debtManagement"
                            className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                            value={formData.debtManagement}
                            disabled={formData.selectedPlan===0}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div>
                        <label htmlFor="financialGoals" className="block text-sm font-medium text-white">Financial Goals:</label>
                        <input
                            type="text"
                            id="financialGoals"
                            name="financialGoals"
                            className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                            value={formData.financialGoals}
                            disabled={formData.selectedPlan===0}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div>
                        <label htmlFor="emergencyFund" className="block text-sm font-medium text-white">Emergency Fund:</label>
                        <input
                            type="text"
                            id="emergencyFund"
                            name="emergencyFund"
                            className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                            value={formData.emergencyFund}
                            disabled={formData.selectedPlan===0}
                            onChange={handleInputChange}
                        />
                    </div>
                </div>
                </>
            )}
        </div>
    )}

    {/* Life Issue Counselling */}
    {parseInt(formData.counsellingType, 10) === 7 && (
        <div className="section border-2 border-green-300 rounded-lg shadow-lg px-6 py-6 bg-black text-white" id="psychometric-tests">
            <button 
                type="button"
                onClick={handleLifeCounsellingClicked}
                className="text-m font-bold mb-4"
            >
                Life Issue Counselling
            </button>
            { lifeCounsellingClicked && (
                <>
                <div className="form-group mt-4 space-y-6 sm:space-y-8">
                    <div>
                        <label htmlFor="stressors" className="block text-sm font-medium text-white">Stressors:</label>
                        <input
                            type="text"
                            id="stressors"
                            name="stressors"
                            className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                            value={formData.stressors}
                            disabled={formData.selectedPlan===0}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div>
                        <label htmlFor="workLifeBalance" className="block text-sm font-medium text-white">Work Life Balance:</label>
                        <input
                            type="text"
                            id="workLifeBalance"
                            name="workLifeBalance"
                            className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                            value={formData.workLifeBalance}
                            disabled={formData.selectedPlan===0}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div>
                        <label htmlFor="personalRelationships" className="block text-sm font-medium text-white">Personal Relationships:</label>
                        <input
                            type="text"
                            id="personalRelationships"
                            name="personalRelationships"
                            className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                            value={formData.personalRelationships}
                            disabled={formData.selectedPlan===0}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div>
                        <label htmlFor="mentalHealth" className="block text-sm font-medium text-white">Mental Health:</label>
                        <input
                            type="text"
                            id="mentalHealth"
                            name="mentalHealth"
                            className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                            value={formData.mentalHealth}
                            disabled={formData.selectedPlan===0}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div>
                        <label htmlFor="copingMechanisms" className="block text-sm font-medium text-white">Coping Mechanisms:</label>
                        <input
                            type="text"
                            id="copingMechanisms"
                            name="copingMechanisms"
                            className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                            value={formData.copingMechanisms}
                            disabled={formData.selectedPlan===0}
                            onChange={handleInputChange}
                        />
                    </div>
                </div>
                </>
            )}
        </div>
    )}

    {/* Marriange / Family Counselling */}
    {parseInt(formData.counsellingType, 10) === 8 && (
        <div className="section border-2 border-green-300 rounded-lg shadow-lg px-6 py-6 bg-black text-white" id="psychometric-tests">
            <button 
                type="button"
                onClick={handleMFCounsellingClicked}
                className="text-m font-bold mb-4"
            >
                Marriage / Family Counselling
            </button>
            { mfCounsellingClicked && (
                <>
                <div className="form-group mt-4 space-y-6 sm:space-y-8">
                    <div>
                        <label htmlFor="communicationPatterns" className="block text-sm font-medium text-white">Communication Patterns:</label>
                        <input
                            type="text"
                            id="communicationPatterns"
                            name="communicationPatterns"
                            className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                            value={formData.communicationPatterns}
                            disabled={formData.selectedPlan === 0}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div>
                        <label htmlFor="emotionalConnection" className="block text-sm font-medium text-white">Emotional Connection:</label>
                        <input
                            type="text"
                            id="emotionalConnection"
                            name="emotionalConnection"
                            className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                            value={formData.emotionalConnection}
                            disabled={formData.selectedPlan === 0}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div>
                        <label htmlFor="conflictResolution" className="block text-sm font-medium text-white">Conflict Resolution:</label>
                        <input
                            type="text"
                            id="conflictResolution"
                            name="conflictResolution"
                            className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                            value={formData.conflictResolution}
                            disabled={formData.selectedPlan === 0}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div>
                        <label htmlFor="timePriorities" className="block text-sm font-medium text-white">Time Priorities:</label>
                        <input
                            type="text"
                            id="timePriorities"
                            name="timePriorities"
                            className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                            value={formData.timePriorities}
                            disabled={formData.selectedPlan === 0}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div>
                        <label htmlFor="trustRespect" className="block text-sm font-medium text-white">Trust & Respect:</label>
                        <input
                            type="text"
                            id="trustRespect"
                            name="trustRespect"
                            className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                            value={formData.trustRespect}
                            disabled={formData.selectedPlan === 0}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div>
                        <label htmlFor="parentingDynamics" className="block text-sm font-medium text-white">Parenting Dynamics:</label>
                        <input
                            type="text"
                            id="parentingDynamics"
                            name="parentingDynamics"
                            className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                            value={formData.parentingDynamics}
                            disabled={formData.selectedPlan === 0}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div>
                        <label htmlFor="supportSystems" className="block text-sm font-medium text-white">Support Systems:</label>
                        <input
                            type="text"
                            id="supportSystems"
                            name="supportSystems"
                            className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                            value={formData.supportSystems}
                            disabled={formData.selectedPlan === 0}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div>
                        <label htmlFor="personalGrowthChange" className="block text-sm font-medium text-white">Personal Growth & Change:</label>
                        <input
                            type="text"
                            id="personalGrowthChange"
                            name="personalGrowthChange"
                            className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                            value={formData.personalGrowthChange}
                            disabled={formData.selectedPlan === 0}
                            onChange={handleInputChange}
                        />
                    </div>
                </div>
                </>
            )}
        </div>
    )}

    {/* Child Behaviour Counselling */}
    {parseInt(formData.counsellingType, 10) === 9 && (
        <div className="section border-2 border-green-300 rounded-lg shadow-lg px-6 py-6 bg-black text-white" id="psychometric-tests">
            <button 
                type="button"
                onClick={handleCBCounsellingClicked}
                className="text-m font-bold mb-4"
            >
                Child Behaviour
            </button>
            { cbCounsellingClicked && (
                <>
                <div>
                    <label htmlFor="emotionalExpression" className="block text-sm font-medium text-white">Emotional Expression:</label>
                    <input
                        type="text"
                        id="emotionalExpression"
                        name="emotionalExpression"
                        className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                        value={formData.emotionalExpression}
                        disabled={formData.selectedPlan === 0}
                        onChange={handleInputChange}
                    />
                </div>
                <div>
                    <label htmlFor="behavioralChallenges" className="block text-sm font-medium text-white">Behavioral Challenges:</label>
                    <input
                        type="text"
                        id="behavioralChallenges"
                        name="behavioralChallenges"
                        className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                        value={formData.behavioralChallenges}
                        disabled={formData.selectedPlan === 0}
                        onChange={handleInputChange}
                    />
                </div>
                <div>
                    <label htmlFor="socialization" className="block text-sm font-medium text-white">Socialization:</label>
                    <input
                        type="text"
                        id="socialization"
                        name="socialization"
                        className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                        value={formData.socialization}
                        disabled={formData.selectedPlan === 0}
                        onChange={handleInputChange}
                    />
                </div>
                <div>
                    <label htmlFor="academicPerformance" className="block text-sm font-medium text-white">Academic Performance:</label>
                    <input
                        type="text"
                        id="academicPerformance"
                        name="academicPerformance"
                        className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                        value={formData.academicPerformance}
                        disabled={formData.selectedPlan === 0}
                        onChange={handleInputChange}
                    />
                </div>
                <div>
                    <label htmlFor="familyDynamics" className="block text-sm font-medium text-white">Family Dynamics:</label>
                    <input
                        type="text"
                        id="familyDynamics"
                        name="familyDynamics"
                        className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                        value={formData.familyDynamics}
                        disabled={formData.selectedPlan === 0}
                        onChange={handleInputChange}
                    />
                </div>
                <div>
                    <label htmlFor="sleepRoutine" className="block text-sm font-medium text-white">Sleep Routine:</label>
                    <input
                        type="text"
                        id="sleepRoutine"
                        name="sleepRoutine"
                        className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                        value={formData.sleepRoutine}
                        disabled={formData.selectedPlan === 0}
                        onChange={handleInputChange}
                    />
                </div>
                <div>
                    <label htmlFor="selfEsteemConfidence" className="block text-sm font-medium text-white">Self-Esteem & Confidence:</label>
                    <input
                        type="text"
                        id="selfEsteemConfidence"
                        name="selfEsteemConfidence"
                        className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                        value={formData.selfEsteemConfidence}
                        disabled={formData.selectedPlan === 0}
                        onChange={handleInputChange}
                    />
                </div>
                <div>
                    <label htmlFor="disciplineExpectations" className="block text-sm font-medium text-white">Discipline Expectations:</label>
                    <input
                        type="text"
                        id="disciplineExpectations"
                        name="disciplineExpectations"
                        className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                        value={formData.disciplineExpectations}
                        disabled={formData.selectedPlan === 0}
                        onChange={handleInputChange}
                    />
                </div>
                <div>
                    <label htmlFor="healthNutrition" className="block text-sm font-medium text-white">Health & Nutrition:</label>
                    <input
                        type="text"
                        id="healthNutrition"
                        name="healthNutrition"
                        className="w-full mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                        value={formData.healthNutrition}
                        disabled={formData.selectedPlan === 0}
                        onChange={handleInputChange}
                    />
                </div>
                </>
            )}
        </div>
    )}

    {/* Goal Setting */}
    <div className="section border-2 border-red-300 rounded-lg shadow-lg px-6 py-6 bg-black text-white" id="goal-setting">
        {/* <h2 className="text-xl font-bold mb-6">4. Goal Setting</h2> */}
        <button 
            type="button"
            onClick={handleGoalClicked}
            className="text-m font-bold mb-4 bg-purple-500"
        >
            Goal Setting
        </button>
        { goalClicked && (
            <>
            <div className="form-group mb-6">
                <label htmlFor="career-goal" className="block text-sm font-semibold mb-2">Career Goal:</label>
                <select
                id="career-goal"
                name="careerGoal"
                className="h-12 px-4 py-2 border-2 border-white rounded-md bg-gray-100 text-black w-full max-w-xs"
                value={formData.careerGoal}
                onChange={handleInputChange}
                >
                <option value="" disabled selected>Select your career goal</option>
                <optgroup label="Engineering & Technology">
                    <option value="jee-main">JEE Main</option>
                    <option value="jee-advanced">JEE Advanced</option>
                    <option value="iit-admission">IIT Admission</option>
                    <option value="engineering-other">Other Engineering Colleges</option>
                </optgroup>
                
                <optgroup label="Medical & Science">
                    <option value="neet">NEET</option>
                    <option value="homi-bhabha">Homi Bhabha Science Exam</option>
                    <option value="kvpy">KVPY (Kishore Vaigyanik Protsahan Yojana)</option>
                    <option value="junior-science-olympiad">Junior Science Olympiad</option>
                </optgroup>
                
                <optgroup label="School-Level Competitions">
                    <option value="ntse">NTSE (National Talent Search Examination)</option>
                    <option value="nso">NSO (National Science Olympiad)</option>
                    <option value="imo">IMO (International Math Olympiad)</option>
                    <option value="nco">NCO (National Cyber Olympiad)</option>
                    <option value="math-olympiad">Math Olympiad</option>
                </optgroup>
                
                <optgroup label="Study Abroad">
                    <option value="sat">SAT</option>
                    <option value="toefl">TOEFL</option>
                    <option value="ielts">IELTS</option>
                </optgroup>
                
                <optgroup label="Other">
                    <option value="csat">CSAT</option>
                    <option value="other-goals">Other Goals</option>
                </optgroup>
                </select>
            </div>

            {/* Timeline */}
            <div className="form-group mb-6">
                <label htmlFor="timeline" className="block text-m font-semibold mb-2">Timeline to Achieve Goal (in months):</label>
                <input
                type="number"
                id="timeline"
                name="timeline"
                style={{ width: "50px" }}
                className="h-12 px-4 py-2 border-2 border-white rounded-md bg-gray-100 text-black w-full max-w-xs"
                value={formData.timeline}
                onChange={handleInputChange}
                />
            </div>

            {/* Milestones Section */}
            <div className="form-group my-6">
                <label htmlFor="milestones" className="text-m font-semibold">Key Milestones:</label>                
                <div className="flex flex-col mb-4 items-center justify-center">
                <button
                    type="button"
                    onClick={toggleSuggestions}
                    className="w-full px-6 py-3 bg-green-500 hover:bg-green-600 text-white font-semibold rounded-lg flex-1 justify-center text-center items-center"
                    aria-label="Toggle milestone suggestions"
                >
                    View Milestone Example! [Use Think5Whys Chronicle to Store and Pull Milestones in convenient way]
                </button>
                </div>

                {showSuggestions && (
                <div className="bg-black p-6 rounded mt-4 shadow-lg">
                    <label htmlFor="milestone-code" className="text-yellow-200 mb-2">Milestone Example. [Use Think5Whys Chronicle to Store and Pull Milestones in convenient way]</label>
                    <p className="text-white">Complete NCERT Basics</p>
                    <p className="text-white">Master High-Weightage Topics</p>
                    <p className="text-white">Finish All Coaching Modules</p>
                    <p className="text-white">Attempt 50+ Mock Tests</p>
                    <p className="text-white">Achieve Target Scores in Test Series</p>

                    <ol className="list-decimal pl-6 text-yellow-200 mt-4">
                    <li className="mb-4">
                        <strong className="text-yellow-200">Complete NCERT Basics</strong>
                        <p className="text-sm">Why?: NCERT is critical for concepts and basic understanding, especially for Chemistry.</p>
                        <p className="text-sm">Sub-milestone: Focus on completing NCERT books for Physics, Chemistry, and Mathematics to build a strong foundation.</p>
                    </li>
                    <li className="mb-4">
                        <strong className="text-yellow-200">Master High-Weightage Topics</strong>
                        <p className="text-sm">Why?: These topics often constitute a significant portion of the IIT-JEE exam.</p>
                        <p className="text-sm">Sub-milestone: Prioritize and master high-scoring topics like Calculus, Mechanics, Organic Chemistry, and Modern Physics.</p>
                    </li>
                    <li className="mb-4">
                        <strong className="text-yellow-200">Finish All Coaching Modules</strong>
                        <p className="text-sm">Why?: Coaching materials are curated to match the JEE syllabus and difficulty level.</p>
                        <p className="text-sm">Sub-milestone: Complete the modules provided by coaching classes (e.g., Allen, FIITJEE) or self-study materials by a specific deadline.</p>
                    </li>
                    <li className="mb-4">
                        <strong className="text-yellow-200">Attempt 50+ Mock Tests</strong>
                        <p className="text-sm">Why?: Practicing full-length tests improves time management, accuracy, and stamina.</p>
                        <p className="text-sm">Sub-milestone: Appear for 50 or more full-length mock tests under exam-like conditions.</p>
                    </li>
                    <li>
                        <strong className="text-yellow-200">Achieve Target Scores in Test Series</strong>
                        <p className="text-sm">Why?: Monitoring progress with target scores boosts confidence and highlights weak areas.</p>
                        <p className="text-sm">Sub-milestone: Set milestones for achieving target scores in specific test series (e.g., scoring 250+ in the JEE Main-level tests).</p>
                    </li>
                    </ol>
                </div>
                )}

                {/* Milestone Code and Buttons */}
                <div className="flex flex-col mt-2">
                    <div className=''>
                        <label htmlFor="milestone-code" className="mr-4 text-sm font-semibold">Think5Whys Chronicle Milestone Code:</label>
                        <input
                            type="text"
                            id="milestone-code"
                            name="milestoneCode"
                            className="h-12 px-4 py-2 border-2 border-white rounded-md bg-gray-100 text-black w-full max-w-xs"
                            value={formData.milestoneCode}
                            disabled={formData.selectedPlan===0}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className='flex flex-row gap-2 place-items-center mt-2'>
                        <button
                            type="button"
                            onClick={handlePullMilestone}
                            disabled={saveClicked || formData.selectedPlan===0}
                            className="w-full bg-yellow-400 hover:bg-yellow-500 text-black font-semibold rounded-lg transition-all duration-300"
                        >
                            Pull Your Milestone Data from Think5Whys Chronicles
                        </button>
                        <button
                            type="button"
                            onClick={handleIsManualMilestone}
                            className="w-full bg-yellow-400 hover:bg-yellow-500 text-black font-semibold rounded-lg transition-all duration-300"
                        >
                            Input Milestones
                        </button>
                    </div>
                </div>
            </div>

            {/* Manual Milestone Input */}
            {isManualMilestone && (
                <div className="mt-6">
                <div className="flex flex-col">
                    <input
                    type="text"
                    id="milestones"
                    name="milestones"
                    value={newMilestone}
                    onChange={handleMilestoneChange}
                    placeholder="Enter key milestone"
                    className="input-milestone h-12 px-4 py-2 border-2 border-white rounded-md bg-gray-100 text-black w-full max-w-xs"
                    />
                    <button
                    type="button"
                    onClick={handleAddMilestone}
                    className="add-button mt-4 h-12 w-full bg-green-500 hover:bg-green-600 text-white font-semibold rounded-lg transition-all duration-300"
                    disabled={formData.milestones.length >= 10 || !newMilestone.trim()}
                    >
                    Add Milestone
                    </button>
                </div>

                {/* List of Added Milestones */}
                <ul className="milestone-list mt-6">
                    {formData.milestones.map((milestone, index) => (
                        <li key={index} className="milestone-item flex justify-between items-center mb-2">
                            <span className="text-white">{index + 1}. {milestone}</span>
                            <button
                            type="button"
                            onClick={() => handleRemoveMilestone(index)}
                            style={{width: "100px"}}
                            className="remove-button bg-red-500 text-white py-2 px-4 rounded-lg hover:bg-red-600"
                            >
                            Remove
                            </button>
                        </li>
                    ))}
                </ul>
                {formData.milestones.length >= 10 && (
                    <p className="text-red-500 mt-2">You can only add up to 10 milestones.</p>
                )}
                </div>
            )}
            </>
        )}
    </div>

    {/* Think5Whys Previous Counselling RCA */}
    <div className="section border-2 border-green-300 rounded-lg shadow-lg px-6 py-6 bg-black text-white" id="psychometric-tests">
        {/* <h2 className="text-xl font-semibold text-center sm:text-left text-purple-700">5. Previous Counselling RCA</h2> */}
        <button 
            type="button"
            onClick={handleRCAClicked}
            className="text-m font-bold mb-4 bg-purple-500"
        >
            Previous Counselling RCA
        </button>
        { rcaClicked && (
            <>
            <div className="form-group mt-4 space-y-6 sm:space-y-8">
                {/* RCA Code Label and Input */}
                <div>
                    <label htmlFor="rca-code" className="block text-sm font-medium text-white">Think5Whys RCA Code:</label>
                    <input
                        type="text"
                        id="rcaCode"
                        name="rcaCode"
                        className="w-full md:w-2/3 lg:w-1/2 mt-2 p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                        value={formData.rcaCode}
                        disabled={formData.selectedPlan===0}
                        onChange={handleInputChange}
                    />
                </div>

                {/* Pull Data Button */}
                <div>
                    <button
                        type="button"
                        onClick={handlePullRCAData}
                        disabled={saveClicked || formData.selectedPlan===0}
                        className="w-full sm:w-auto mt-6 bg-purple-600 text-white py-3 px-6 rounded-lg hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                    >
                        Pull Data From Think5Whys RCA Cloud
                    </button>
                </div>
            </div>
            </>
        )}
    </div>

    <div className="section border-2 border-pink-300 rounded-lg shadow-lg px-6 py-6 bg-black text-white">
        <div className='flex flex-row justify-center'>
            <button
                type="button"
                onClick={handleAiPromptClicked}
                disabled={saveClicked}
                className="remove-button text-white mt-4 bg-blue-600 p-3 rounded-md w-full md:w-auto hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-purple-500"
            >
                Generate AI Assessment Prompt
            </button>
            {/* <button
                type="button"
                onClick={handleJobAiPromptClicked}
                disabled={saveClicked}
                className="remove-button text-white ml-4 mt-4 bg-blue-600 p-3 rounded-md w-full md:w-auto hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-purple-500"
            >
                Generate Job Assessment Prompt
            </button> */}
            <button
                type="button"
                onClick={handleAiAssessmentClicked}
                disabled={saveClicked || formData.selectedPlan===0}
                className="remove-button text-white ml-4 mt-4 bg-blue-600 p-3 rounded-md w-full md:w-auto hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-purple-500"
            >
                Submit For AI Assessment
            </button>
        </div>
        {aiPromptClicked && (
            <>
            <div className="px-2 bg-black">
                <label htmlFor="ai-prompt" className="block text-m font-medium">Ask AI Assessment Prompt:</label>
                <textarea
                    id="aiAssessmentPrompt"
                    name="aiAssessmentPrompt"
                    className="mt-2 p-3 bg-black text-white rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={formData.aiAssessmentPrompt}
                    onChange={handleInputChange}
                    style={{ minHeight: "500px", minWidth: "100%" }}
                />
            </div>
            <div className="px-2">
                <label htmlFor="ai-assessment" className="block text-m font-medium text-yellow-200">AI Assessment:</label>
                <textarea
                    id="aiAssessment"
                    name="aiAssessment"
                    placeholder="Paste AI Assessment"
                    className="mt-2 p-3 bg-gray-800 text-white rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={formData.aiAssessment}
                    onChange={handleInputChange}
                    style={{ minHeight: "500px", minWidth: "100%" }}
                />
            </div>
            </>
        )}
        {aiAssessmentClicked && (
            <>
            <div className="px-4">
                <p className="block text-m font-medium text-yellow-200">Auto AI Assessment:</p>
                <p></p>
            </div>
            </>
        )}
    </div>

    <div className="section border-2 border-yellow-300 rounded-lg shadow-lg px-6 py-6 bg-black text-white">
        <label htmlFor="rca-code" className="block text-sm font-medium text-yellow-200 w-40">My Counsellor Code:</label>
        <div className='flex flex-col'>
            <input
                type="text"
                id="myCounsellor"
                name="myCounsellor"
                style={{width: "250px"}}
                value={formData.myCounsellor}
                className="h-12 mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"                
                onChange={handleInputChange}
            />
            <div className='flex flex-col'>
                {counsellorCodeStatus === true ? (
                    <span className="text-green-500 mt-4">
                        Counsellor Code Successfully Validated (Counsellor Name: {counsellorName})
                    </span>
                ) : counsellorCodeStatus === false ? (
                    <span className="text-red-500 mt-4">{error}</span>
                ) : null}

                <button
                    className="w-40 mt-2 button-green h-12 bg-teal-600 p-3 rounded-md hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-teal-500"
                    type="submit"
                    onClick={counsellorCodeValidationClicked}
                    disabled={saveClicked || formData.selectedPlan===0}
                >
                    Verify
                </button>
            </div>
        </div>
    </div>
    <div className="section border-2 border-pink-300 rounded-lg shadow-lg px-6 py-6 bg-black text-white">
        <label htmlFor="rca-code" className="block text-sm font-medium text-yellow-200">My Coupon Code:</label>

        <div className='flex flex-row'>
            <input
                type="text"
                id="myCoupon"
                name="myCoupon"
                style={{width: "250px"}}
                className="h-12 mt-2 p-3 border text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 transition duration-200 ease-in-out"
                value={formData.myCoupon}
                onChange={handleInputChange}
            />
            <button
                className="w-40 ml-4 mt-2 button-green h-12 bg-teal-600 p-3 rounded-md hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-teal-500"
                type="submit"
                // onClick={handleVerifyCoupon}
                disabled={true || saveClicked || formData.selectedPlan===0}
            >
                Verify
            </button>
        </div>
    </div>
    <div className="section border-2 border-green-300 rounded-lg shadow-lg px-6 py-6 bg-black text-white">
        <button
            className="button-green bg-teal-600 mt-4 ml-4 w-full md:w-auto p-3 rounded-md hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-teal-500"
            type="submit"
            onClick={handleSaveAIAssessment}
            disabled={saveClicked || !paymentConfirmClicked || formData.selectedPlan===0}
        >
            Save to Think5Whys AI Assessment Cloud
        </button>
        {saveClicked && (
            <div className='text-lg ml-4 text-green-200'>
                <p className='text-green-200'>Data Successfully Saved!!</p>
            </div>
        )}
    </div>
    <div>
    </div>
    <div className="section border-2 border-green-300 rounded-lg shadow-lg px-6 py-6 bg-black text-white">
        <button
            className="button-green ml-4 bg-blue-600 mt-6 w-full md:w-auto p-3 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            type="submit"
            onClick={handleBookCouncellor}
        >
            Book Free Counseling Schedule With Our Counsellors
        </button>
      </div>
      <footer className="bg-black border-t border-blue-400 text-white py-2 px-4 mt-2">
            <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left space-y-4 md:space-y-0">
            <p className="text-xs sm:text-sm">&copy; 2025 Think5Whys Global DeepTech Solutions.</p>
            <div className="flex flex-row gap-2 sm:gap-6 text-xs sm:text-sm">
                <Link to="/about-us" className="text-white hover:text-purple-200 transition">About</Link>
                <Link to="/privacy-policy" className="text-white hover:text-purple-200 transition">Privacy Policy</Link>
                <Link to="/terms-of-use" className="text-white hover:text-purple-200 transition">Terms of Use</Link>
                <Link to="/contact-us" className="text-white hover:text-purple-200 transition">Contact</Link>
            </div>
            </div>
        </footer>      
    </div>
  );
};

export default AICounselling;
